export const irTimeline = [
  {
    year: '2023',
    title: '회사 설립',
    desc: 'AI 에너지 플랫폼 기업 (주)에너버즈 설립. 초기 팀 구성 및 핵심 기술 개발 시작.',
  },
  {
    year: '2024',
    title: '기술 검증 및 특허 출원',
    desc: '4대 핵심 기술 프로토타입 개발 완료. 국내외 특허 6건 출원. 정부 과제 2건 수주.',
  },
  {
    year: '2025',
    title: '시장 진출 및 파트너십 확대',
    desc: 'B2B 솔루션 상용화. 주요 에너지 기업과 MOU 체결. Series A 투자 유치.',
  },
  {
    year: '2026',
    title: '글로벌 확장 및 스케일업',
    desc: 'PCT 특허 출원 및 해외 시장 진출. 디지털트윈 데모 상용화. 투자 유치 확대.',
  },
];

export const investmentPoints = [
  {
    title: '독보적 AI 기술',
    desc: 'AI Energy Platform과 Digital Twin을 융합한 국내 유일의 에너지 AI 전문 기술 보유',
    icon: 'ri-brain-line',
  },
  {
    title: '정부 과제 수주',
    desc: '산업통상자원부 등 주요 정부 에너지 과제 다수 수주, B2G 시장 입지 확보',
    icon: 'ri-government-line',
  },
  {
    title: '글로벌 특허 전략',
    desc: 'PCT 출원을 통한 미국·유럽·중국 글로벌 IP 포트폴리오 구축 중',
    icon: 'ri-global-line',
  },
  {
    title: '성장 시장 진입',
    desc: '탄소중립 및 재생에너지 시장 고속 성장 속에서 차세대 에너지 인프라 선도',
    icon: 'ri-arrow-up-circle-line',
  },
];

export const irDownloads = [
  {
    title: '2026년 IR 자료',
    desc: '기업 개요, 성장 전략, 투자 포인트',
    format: 'PDF',
  },
  {
    title: '기술 소개서',
    desc: '4대 핵심 기술 상세 설명 및 로드맵',
    format: 'PDF',
  },
  {
    title: '특허 포트폴리오',
    desc: '특허 현황 및 PCT 출원 계획',
    format: 'PDF',
  },
];